import { Api } from './Api';

export class Subscription {
  static buySubscription(body: any): ReturnType<typeof Api.post> {
    return Api.post('dashboard/subscription/', body);
  }
  static updateSubscription(body: any): ReturnType<typeof Api.put> {
    return Api.put('dashboard/subscription/', body);
  }

  static deleteSubscription(): ReturnType<typeof Api.delete> {
    return Api.delete('dashboard/subscription/');
  }

  // static startSubscription(): ReturnType<typeof Api.get> {
  //   return Api.get('dashboard/subscription/');
  // }
}
